import { useMemo } from "react";
import WebApp from "@twa-dev/sdk";

export function useTelegram() {
  const initData = useMemo(
    () => WebApp.initDataUnsafe,
    [],
  );

  const user = initData?.user ?? null;
  const themeParams = WebApp.themeParams;
  const colorScheme = WebApp.colorScheme;

  const cssVars = useMemo(
    () => ({
      "--tg-bg": themeParams.bg_color ?? (colorScheme === "dark" ? "#1c1c1d" : "#ffffff"),
      "--tg-text": themeParams.text_color ?? (colorScheme === "dark" ? "#ffffff" : "#000000"),
      "--tg-hint": themeParams.hint_color ?? (colorScheme === "dark" ? "#aaaaaa" : "#999999"),
      "--tg-button": themeParams.button_color ?? "#2AABEE",
      "--tg-button-text": themeParams.button_text_color ?? "#ffffff",
      "--tg-secondary-bg": themeParams.secondary_bg_color ?? (colorScheme === "dark" ? "#2c2c2e" : "#f0f0f0"),
      "--tg-section-bg": themeParams.section_bg_color ?? (colorScheme === "dark" ? "#1c1c1d" : "#ffffff"),
      "--tg-destructive": themeParams.destructive_text_color ?? "#ff3b30",
    }),
    [themeParams, colorScheme],
  );

  return { initData, user, themeParams, colorScheme, cssVars };
}
